import { render, staticRenderFns } from "./machinehaltpage.vue?vue&type=template&id=4c0eab16&scoped=true"
import script from "./machinehaltpage.vue?vue&type=script&lang=js"
export * from "./machinehaltpage.vue?vue&type=script&lang=js"
import style0 from "./machinehaltpage.vue?vue&type=style&index=0&id=4c0eab16&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0eab16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0eab16')) {
      api.createRecord('4c0eab16', component.options)
    } else {
      api.reload('4c0eab16', component.options)
    }
    module.hot.accept("./machinehaltpage.vue?vue&type=template&id=4c0eab16&scoped=true", function () {
      api.rerender('4c0eab16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/machinehaltpage/machinehaltpage.vue"
export default component.exports